"use strict";

exports.__esModule = true;
exports.skins = exports.directions = void 0;
var directions = exports.directions = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
var skins = exports.skins = {
  light: 'light',
  dark: 'dark',
  standard: 'standard',
  warning: 'warning',
  destructive: 'destructive',
  success: 'success',
  premium: 'premium'
};
//# sourceMappingURL=constants.js.map